export const {
    VITE_SST_API_URL: SST_API_URL,
    VITE_SWIFTID_KYC_DOMAIN: SWIFTID_KYC_DOMAIN,
    VITE_AWS_USER_POOLS_ID: AWS_USER_POOLS_ID,
} = import.meta.env
export const { VITE_ENV: ENV } = import.meta.env
export const { VITE_DEVICE_AUTH_INACTIVITY_MINUTES: DEVICE_AUTH_INACTIVITY_MINUTES = 5 } = import.meta.env
// True under Vite's own dev server AND on the deployed `dev` stage (VITE_ENV is written to
// `.env` by the Makefile's `prepare_vite_env` at build time for every stage). Don't use this
// for anything that depends on actually running inside the local Vite dev server itself
// (e.g. a dev-server-only proxy in vite.config.ts) — use IS_LOCAL_DEV_SERVER for that.
export const IS_DEV = import.meta.env.DEV || import.meta.env.VITE_ENV === 'dev'

// Narrower than IS_DEV on purpose: true only inside Vite's own dev server, never on a
// deployed build (including the dev stage, which serves static files with no dev server
// behind them). See bffBaseUrl.ts for why this distinction matters.
export const IS_LOCAL_DEV_SERVER = import.meta.env.DEV
